module.exports = __webpack_public_path__ + "img/shakes_list.b9bb1063.png";